export const PROFILE_PICTURE_HEADER = '';
export const PROFILE_PICTURE_ALT = ' profile picture';
export const PROFILE_PICTURE_ID = 'Image';
export const NAME_HEADER = 'Name';
export const EMAIL_HEADER = 'Email';
export const OFFICE_HEADER = 'Office';
export const ROLE_HEADER = 'Role';
export const DATE_JOINED_HEADER = 'DateJoined';
